import { Grid, Typography } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import RoundButton from "../../RoundButton";
import { Stack } from "@mui/system";
import CustomDatePicker from "../../CustomDatePicker";
import { useTranslation } from "react-i18next";
import { getTimeZone } from "../../../utils/momentUtils";
import { MOMENT_CONSTANTS } from "../../../utils/momentUtils";
import { useReservationSchema } from "../../../validations/dailyReservationScheme";

const MonthlyReservationForm = (props) => {
  const { monthReservationScheme } = useReservationSchema();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    resolver: yupResolver(monthReservationScheme),
  });

  const { t } = useTranslation();

  return (
    <form
      onSubmit={handleSubmit((data) => {
        props?.handleSubmit(data);
      })}
    >
      <Grid
        container
        rowSpacing={1}
        sx={{ mt: 2 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid item xs={12}>
          <Controller
            name="fromDate"
            control={control}
            render={({ field }) => (
              <CustomDatePicker
                {...field}
                size="small"
                required
                minDays={0}
                maxDays={30}
                inputFormat={MOMENT_CONSTANTS.date.monthDayYear}
                outputFormat={MOMENT_CONSTANTS.date.monthDayYear}
                timeZone={props?.timeZone}
                label={
                  t("pages.makeReservation.input01") +
                  ` (${getTimeZone(props?.timeZone)})`
                }
                placeholder={t("pages.makeReservation.input01")}
                name="fromDate"
                error={!!errors.fromDate}
                helperText={errors.fromDate?.message}
              />
            )}
          />
        </Grid>
      </Grid>

      <Stack
        sx={{
          mt: 2,
          position: "absolute",
          bottom: 0,
          width: "90%",
          right: 0,
          left: 0,
          marginRight: "auto",
          marginLeft: "auto",
        }}
        spacing={2}
      >
        <RoundButton
          sx={{ mt: 5, mb: 3 }}
          style={{
            width: "100%",
          }}
          size="large"
          fullWidth
          variant="contained"
          type="submit"
          color="primary"
          rounded
          disabled={!isValid} // Disable button if form is invalid
        >
          <Typography variant="buttonText" color="common.buttonText">
            {t("commonLabels.text17")}
          </Typography>
        </RoundButton>
      </Stack>
    </form>
  );
};
export default MonthlyReservationForm;
